import { EnvService } from '@hub/services/core/env-service';

// Constants
export const IS_PRODUCTION = EnvService.isProduction;

// Helper functions
export const handlePlatformDownload = (link: string): void => {
  window.open(link, '_blank');
};
